import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AuthContextType {
  sessionId: string | null;
  isAuthenticated: boolean;
  login: (sessionId: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [sessionId, setSessionId] = useState<string | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const login = (newSessionId: string) => {
    setSessionId(newSessionId);
    setIsAuthenticated(true);
  };

  const logout = () => {
    setSessionId(null);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ sessionId, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}; 